/**
 * 文字列してファイル内容を取得する
 *
 * @param {File} file
 */
export function readAsText(file) {
  return new Promise(r => {
    const reader = new FileReader()
    reader.onload = () => r(reader.result)
    reader.readAsText(file)
  })
}

/**
 * 文字列のリストしてファイル内容を読む
 *
 * 空行は除外される。
 *
 * @param {File} file
 */
export function readAsArray(file) {
  // TODO 一気に全読み込みすると大変そうなので、後でブロック毎読む、などに変更する
  return readAsText(file).then(content => {
    return content.split('\n').filter(l => l)
  })
}
